"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MangopayWalletAmountPair.js.map